import { IFormSchema } from "@graffer-inc/form-schema";
import { BaseEntity } from "../base/base-entity";
import { SurveyFormSchema } from "./form-schema/survey-form-schema";

export type SurveyType = {
  id: string;
  name: string;
  orgId: string;
  groupIds: string[];
  publishSetting: SurveyPublishSetting;
  draft: SurveyDetail;
  published?: SurveyDetail;
  publishStatus: SurveyPublishStatus;
  customPath?: string;
  isExcludeFromSearch: boolean;
  isNotifyArrival: boolean;
  createdAt: Date;
  updatedAt: Date;
};

export type SurveyDetail = {
  formSchema: IFormSchema;
};

export type SurveyPublishSetting = {
  startAcceptAt?: Date;
  endAcceptAt?: Date;
  publishAt?: Date;
  unPublishAt?: Date;
  isPausingAccept: boolean;
};
export const SurveyStatusList = [
  "DRAFT",
  "BEFORE_PUBLISH",
  "BEFORE_ACCEPTING",
  "ACCEPTING",
  "FINISHED_ACCEPTING",
  "UNPUBLISHED",
  "PAUSING_ACCEPT",
] as const;
export type SurveyPublishStatus = (typeof SurveyStatusList)[number];

export class SurveyEntity extends BaseEntity {
  id: string;
  name: string;
  orgId: string;
  groupIds: string[];
  publishSetting: SurveyPublishSetting;
  draft: {
    formSchema: SurveyFormSchema;
  };
  published?: {
    formSchema: SurveyFormSchema;
  };
  publishStatus: SurveyPublishStatus;
  customPath?: string;
  isExcludeFromSearch: boolean;
  isNotifyArrival: boolean;
  createdAt: Date;
  updatedAt: Date;

  constructor(values: SurveyType) {
    super();
    this.id = values.id;
    this.name = values.name;
    this.orgId = values.orgId;
    this.groupIds = values.groupIds;
    this.publishSetting = values.publishSetting;
    this.publishStatus = values.publishStatus;
    this.draft = {
      ...values.draft,
      formSchema: SurveyFormSchema.fromJSON(values.draft.formSchema),
    };
    if (values.published) {
      this.published = {
        ...values.published,
        formSchema: SurveyFormSchema.fromJSON(values.published.formSchema),
      };
    }
    this.customPath = values.customPath;
    this.isExcludeFromSearch = values.isExcludeFromSearch;
    this.isNotifyArrival = values.isNotifyArrival;
    this.createdAt = values.createdAt;
    this.updatedAt = values.updatedAt;
  }

  static fromJSON(values: SurveyType) {
    return new SurveyEntity(values);
  }
}
